export default "__VITE_ASSET__D7p3Zmnx__"